(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-id/assets/javascripts/use-coupon-type.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-id/assets/javascripts/use-coupon-type.js');
"use strict";

const CouponIdContext = svs.components.tipsen.couponId.CouponIdContext;
const _React = React,
  useContext = _React.useContext;
const useCouponType = () => {
  const context = useContext(CouponIdContext);
  if ((context === null || context === void 0 ? void 0 : context.type) === undefined) {
    throw new Error('useCouponType must be used within a CouponIdProvider');
  }
  return context.type;
};
setGlobal('svs.components.tipsen.couponId.useCouponType', useCouponType);

 })(window);